import { FC } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

import StyledGooglePlayButton from "./styling/GooglePlayButton.styles";
import { GooglePlayButtonProps } from "./GooglePlayButton.types";
import { GooglePlayLogo, GooglePlayText } from "./svgs";

const GooglePlayButton: FC<GooglePlayButtonProps> = ({
	className,
	...props
}) => {
	const block = new BemIt("GooglePlayButton");

	return (
		<StyledGooglePlayButton
			className={addClass(className).after(block)}
			{...props}
		>
			<GooglePlayLogo className={block.el("icon").out} />
			<GooglePlayText className={block.el("text").out} />
		</StyledGooglePlayButton>
	);
};

export default GooglePlayButton;
